import { LTText } from '@lambdatestincprivate/lt-components';
import { Byline } from './Byline';
import { StatusChip } from './StatusChip';
import styles from './run-header.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function RunHeader(_ref) {
  var run = _ref.run;
  return /*#__PURE__*/_jsxs("header", {
    className: styles.header,
    children: [/*#__PURE__*/_jsx(LTText, {
      as: "h1",
      className: styles.title,
      title: run.title,
      color: "var(--ev-fg)",
      style: {
        fontSize: '20px',
        lineHeight: '28px',
        fontWeight: 600
      },
      children: run.title
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.statusLine,
      children: [/*#__PURE__*/_jsx(StatusChip, {
        chip: run.chip
      }), /*#__PURE__*/_jsx("span", {
        className: styles.dot,
        "aria-hidden": "true"
      }), /*#__PURE__*/_jsx(Byline, {
        run: run
      })]
    })]
  });
}